import { render } from "./Document.vue?vue&type=template&id=36f0dbf2&lang=pug"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"
script.render = render

export default script